import {
  pipe,
  map,
  defaultTo,
  split,
  unnest,
  reduce,
  toPairs,
  join,
  pick,
  cond,
  isNil,
  always,
  T,
  inc,
} from 'ramda'

/**
 * parseRawSearch
 *  Turn ['search:is:xxx,someField:operation:value', 'someOtherField:is:yyy']
 *  into [
 *    ['search', 'is', 'xxx'],
 *    ['someField, 'operation', 'value'],
 *    ['someOtherField', 'is', 'yyy'],
 *  ]
 */
const parseRawSearch = pipe(
  map(
    pipe(
      defaultTo(''),
      split(','),
      map(text => {
        const [source, operator, ...rest] = text.split(':')
        return [source, operator, rest.join(':')]
      }),
    ),
  ),
  unnest,
)

/**
 * combineSearch
 *  First parse both `nextSearch` and `search` into ['key', 'operation', 'value'],
 *  and reduce it base on `key` which the latter nextSearch keys will overwrite,
 *  after removing redundants, join them back together to form a search param.
 */
const combineSearch = (nextSearch, search) =>
  nextSearch && search
    ? pipe(
        parseRawSearch,
        reduce(
          (acc, [key, operation, value]) => ({
            ...acc,
            [key]: `${operation}:${value}`,
          }),
          {},
        ),
        toPairs,
        map(([key, rest]) => `${key}:${rest}`),
        join(','),
      )([search, nextSearch])
    : nextSearch || search

/**
 * TODO
 * @param {*} paginationState
 * @param {*} inputQuery
 * @param {*} cachedKeys
 */
const makePaginationParams = (
  paginationState = {},
  inputQuery = {},
  cachedKeys = ['page', 'size', 'sort', 'sortOrder', 'search'],
) => {
  const state = paginationState.toJS ? paginationState.toJS() : paginationState
  const { page, search, ...otherParams } = pick(cachedKeys, state)
  const { search: nextSearch } = inputQuery

  return {
    page: cond([
      [isNil, always(0)],
      [T, inc],
    ])(page),
    ...otherParams,
    ...inputQuery,
    search: combineSearch(nextSearch, search),
  }
}

export default makePaginationParams
